import * as React from "react";
import {Document, Page, StyleSheet, Text, View, Image} from "@react-pdf/renderer";
import nluisLogo from "./../../../../resources/img/nlus.png"
import Table from "./report_table";
import {ProjectsService} from "../../../../service/v1/projects";
import {ReportService} from "../../../../service/v1/report";

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white'
    },
    section: {
        margin: 5,
        padding: 5,
        flexGrow: 1,
        textAlign: "center",
        fontSize: 14
    },
    image: {
        width: '25%',
        height: '28%',
        alignSelf: "center"
    }
});

const data = {
    id: "5df3180a09ea16dc4b95f910",
    header: [{
        object1: 'S/N',
        object2: 'Region',
        object3: 'District',
        object4: 'Ward',
        object5: 'Active',
        object6: 'Expired'
    }],
    items: [
        {
            object1: 1,
            object2: "Dodoma",
            object3: 'Chamwino',
            object4: 'Dege',
            object6: '55',
            object5: '28'
        },
        {
            object1: 2,
            object2: "Dodoma",
            object3: 'Chamwino',
            object4: 'Mzizima',
            object5: '25',
            object6: '55'
        },
        {
            object1: 3,
            object2: "Dodoma",
            object3: 'Chamwino',
            object4: 'Mlali',
            object5: '24',
            object6: '55'
        },
    ],
};

export default class VillageStatusLandUseReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: null
        }
        VillageStatusLandUseReport.self = this
        this.getReport = this.getReport.bind(this)
    }

    componentDidMount() {
        this.getReport()
    }


    getReport() {
        ReportService.fetchReport().then(r => {
            try {
                console.log('YYYYYYYY')
                this.setState({
                    report: r,
                })
            } catch (e) {
                console.log(e)
            }
            console.log('RRRRRRR')
        })
    }

    render() {
        return (<Document
            file={{url:'http://154.118.227.140:8002/api/v1/reports/land-uses-area'}}>
            {/*<Page size="A4" style={styles.page} orientation={"landscape"}>
                {this.state.report}]
            </Page>*/}
        </Document>)

    }
}
